import { submitMove, submitMoveWithAction } from "./move";
import {
  sendEventActionToGate,
  sendEventToGate,
  sendMergeToGate,
  sendMiniActionsToGate,
} from "./request";
import { getMergeParameters, getPageId } from "./url-helper";
import { createEventMergeContext, replaceContext, createContext, closeContext } from "./bct";
import { trackOnNextPageImpression } from "./link-data";
import { get as toggleActive } from "@otto-ec/global-resources/toggle";
import { events, eventQBus as untypedEventQBus } from "@otto-ec/global-resources/event-q-bus";
import { Action, Feature, MiniAction } from "./feature-typing";
import { TrackingQBusEvents } from "../event-q-bus";
import type { DataContainer } from "./datacontainer";
import type { OnLateMergeStrategy } from "./request-typings";
import { addMiniActions } from "./toggles";
import { captureError } from "@otto-ec/global-resources/apm";

const eventQBus = events<TrackingQBusEvents>();

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const topics = {
  submitEvent: "tracking.bct.submitEvent",
  addActionToEvent: "tracking.bct.addActionToEvent",
  addToPageImpression: "tracking.bct.addToPageImpression",
  addToPageImpressionWithStrategy: "tracking.bct.addToPageImpressionWithStrategy",
  addToEvent: "tracking.bct.addToEvent",
  getMergeParameters: "tracking.bct.getMergeParameters",
  getPageId: "tracking.bct.getPageId",
  createEventMergeContext: "tracking.bct.createEventContext",
  replaceContext: "tracking.bct.replaceContext",
  createContext: "tracking.bct.createContext",
  closeContext: "tracking.bct.closeContext",
  submitMove: "tracking.bct.submitMove",
  submitMoveAction: "tracking.bct.submitMoveAction",
  addFeaturesToPageImpression: "tracking.bct.addFeaturesToPageImpression",
  submitAction: "tracking.bct.submitAction",
  trackOnNextPageImpression: "tracking.bct.trackOnNextPageImpression",
  submitMiniActions: "tracking.bct.submitMiniActions",
} as const;

function onSubmitMove(
  dataContainer: DataContainer,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const moveResponse = submitMove(dataContainer);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, moveResponse);
  }
}

function onSubmitMoveAction(
  dataContainer: DataContainer,
  action: Action,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const moveResponse = submitMoveWithAction(dataContainer, action);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, moveResponse);
  }
}

function onSubmitEvent(
  dataContainer: DataContainer,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const eventResponse = sendEventToGate(dataContainer);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, eventResponse);
  }
}

function onAddActionToEvent(
  actionContainer: Action,
  mergeId: string,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const actionResponse = sendEventActionToGate({}, actionContainer, mergeId);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, actionResponse);
  }
}

function onSubmitAction(
  dataContainer: DataContainer,
  action: Action,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const actionResponse = sendEventActionToGate(dataContainer, action);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, actionResponse);
  }
}

function onCreateEventContext(responseEventName?: `${string}.${string}.${string}`) {
  const eventContext = createEventMergeContext();
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, eventContext);
  }
}

function onGetMergeParameters(responseEventName?: `${string}.${string}.${string}`) {
  const mergeParameters = getMergeParameters();
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, mergeParameters);
  }
}

function onGetPageId(responseEventName?: `${string}.${string}.${string}`) {
  const pageId = getPageId();
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, pageId);
  }
}

function onReplaceContext(
  id: string,
  url: string,
  dataContainer: DataContainer,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const currentContextStack = replaceContext(id, url, dataContainer);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, currentContextStack);
  }
}

function onCreateContext(
  id: string,
  url: string,
  dataContainer?: DataContainer,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const currentContextStack = createContext(id, url, dataContainer);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, currentContextStack);
  }
}

function onCloseContext(responseEventName?: `${string}.${string}.${string}`) {
  const closedContext = closeContext();
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, closedContext);
  }
}

function onAddToEvent(
  dataContainer: DataContainer,
  eventMergeId: string | undefined,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const eventMergeResponse = sendEventToGate(dataContainer, eventMergeId);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, eventMergeResponse);
  }
}

function onMerge(
  dataContainer: DataContainer,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const mergeResponse = sendMergeToGate(dataContainer, "default");
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, mergeResponse);
  }
}

function onStrategicMerge(
  dataContainer: DataContainer,
  onLate: OnLateMergeStrategy,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const mergeResponse = sendMergeToGate(dataContainer, onLate);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, mergeResponse);
  }
}

function onTrackOnNextPageImpression(
  dataContainer: DataContainer,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const storeResponse = trackOnNextPageImpression(dataContainer);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, storeResponse);
  }
}

function onMiniAction(
  updates: Array<MiniAction>,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const updateResponse = sendMiniActionsToGate(updates);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, updateResponse);
  }
}

/**
 *
 *
 *
 *
 */
function onAddFeaturesToPageImpression(
  features: Array<Feature>,
  responseEventName?: `${string}.${string}.${string}`,
) {
  const response = sendMergeToGate({}, "default", features);
  if (responseEventName) {
    untypedEventQBus.emit(responseEventName, response);
  }
}

function captureDeprecatedApiCall<T, A extends unknown[]>(fn: (this: T, ...args: A) => void) {
  return function (this: T, ...args: A) {
    captureError(
      new Error("Deprecated EventQBus tracking API used"),
      { team: "tracking", service: "bct" },
      { custom: { additionalInfo: "Deprecated EventQBus tracking API used" } },
    );

    return fn.apply(this, args);
  }
}

/**
 *
 *
 *
 */
export default function init(): () => void {
  const wrappedOnMiniAction = captureDeprecatedApiCall(onMiniAction)
  const wrappedOnSubmitMove = captureDeprecatedApiCall(onSubmitMove)
  const wrappedOnSubmitMoveAction = captureDeprecatedApiCall(onSubmitMoveAction)
  const wrappedOnAddToEvent = captureDeprecatedApiCall(onAddToEvent)
  const wrappedOnMerge = captureDeprecatedApiCall(onMerge)
  const wrappedOnStrategicMerge = captureDeprecatedApiCall(onStrategicMerge)
  const wrappedOnCloseContext = captureDeprecatedApiCall(onCloseContext)
  const wrappedOnCreateContext = captureDeprecatedApiCall(onCreateContext)
  const wrappedOnCreateEventContext = captureDeprecatedApiCall(onCreateEventContext)
  const wrappedOnSubmitEvent = captureDeprecatedApiCall(onSubmitEvent)
  const wrappedOnGetMergeParameters = captureDeprecatedApiCall(onGetMergeParameters)
  const wrappedOnGetPageId = captureDeprecatedApiCall(onGetPageId)
  const wrappedOnAddFeaturesToPageImpression = captureDeprecatedApiCall(onAddFeaturesToPageImpression)
  const wrappedOnSubmitAction = captureDeprecatedApiCall(onSubmitAction)
  const wrappedOnAddActionToEvent = captureDeprecatedApiCall(onAddActionToEvent)
  const wrappedOnTrackOnNextPageImpression = captureDeprecatedApiCall(onTrackOnNextPageImpression)
  const wrappedOnReplaceContext = captureDeprecatedApiCall(onReplaceContext)

  if (toggleActive(addMiniActions, false)) {
    eventQBus.on(topics.submitMiniActions, wrappedOnMiniAction);
  }

  eventQBus.on(topics.submitMove, wrappedOnSubmitMove);
  eventQBus.on(topics.submitMoveAction, wrappedOnSubmitMoveAction);
  eventQBus.on(topics.addToEvent, wrappedOnAddToEvent);
  eventQBus.on(topics.addToPageImpression, wrappedOnMerge);
  eventQBus.on(topics.addToPageImpressionWithStrategy, wrappedOnStrategicMerge);
  eventQBus.on(topics.closeContext, wrappedOnCloseContext);
  eventQBus.on(topics.createContext, wrappedOnCreateContext);
  eventQBus.on(topics.createEventMergeContext, wrappedOnCreateEventContext);
  eventQBus.on(topics.submitEvent, wrappedOnSubmitEvent);
  eventQBus.on(topics.getMergeParameters, wrappedOnGetMergeParameters);
  eventQBus.on(topics.getPageId, wrappedOnGetPageId);
  eventQBus.on(topics.addFeaturesToPageImpression, wrappedOnAddFeaturesToPageImpression);
  eventQBus.on(topics.submitAction, wrappedOnSubmitAction);
  eventQBus.on(topics.addActionToEvent, wrappedOnAddActionToEvent);
  eventQBus.on(topics.trackOnNextPageImpression, wrappedOnTrackOnNextPageImpression);
  eventQBus.on(topics.replaceContext, wrappedOnReplaceContext);

  return () => {
    eventQBus.off(topics.submitMove, wrappedOnSubmitMove);
    eventQBus.off(topics.submitMoveAction, wrappedOnSubmitMoveAction);
    eventQBus.off(topics.addToEvent, wrappedOnAddToEvent);
    eventQBus.off(topics.addToPageImpression, wrappedOnMerge);
    eventQBus.off(topics.addToPageImpressionWithStrategy, wrappedOnStrategicMerge);
    eventQBus.off(topics.closeContext, wrappedOnCloseContext);
    eventQBus.off(topics.createContext, wrappedOnCreateContext);
    eventQBus.off(topics.createEventMergeContext, wrappedOnCreateEventContext);
    eventQBus.off(topics.submitEvent, wrappedOnSubmitEvent);
    eventQBus.off(topics.getMergeParameters, wrappedOnGetMergeParameters);
    eventQBus.off(topics.getPageId, wrappedOnGetPageId);
    eventQBus.off(topics.addFeaturesToPageImpression, wrappedOnAddFeaturesToPageImpression);
    eventQBus.off(topics.submitAction, wrappedOnSubmitAction);
    eventQBus.off(topics.addActionToEvent, wrappedOnAddActionToEvent);
    eventQBus.off(topics.trackOnNextPageImpression, wrappedOnTrackOnNextPageImpression);
    eventQBus.off(topics.replaceContext, wrappedOnReplaceContext);
  };
}
